module.exports = __webpack_public_path__ + "img/outlanderBig.a0945803.jpg";